import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;
`;

export const ColorPicker = styled.input`
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  margin-bottom: 2px;
  padding: 2px;
  border: 1px solid ${({ theme }) => theme.colors.semantic.border.default};
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.semantic.surface.card};
  cursor: pointer;
`;

export const InputWrapper = styled.div`
  flex: 1;
`;
